// `React` must be in SCOPE, not merely resolvable: the kiosk renderchecks run ts-node with
// `"jsx": "react"` (the classic runtime), which compiles this file's JSX to
// `React.createElement`. The app bundlers use the automatic runtime and need no import, so a
// missing one here builds clean and throws only in those node-only gates.
import React from "react";
import Svg, { Path } from "react-native-svg";

export function HomeIcon({ color, width, height }: { color: string; width?: number; height?: number }) {
  return (
    <Svg
      width={width ?? 16}
      height={height ?? 18}
      viewBox="0 0 16 18"
      fill="none"
    >
      <Path
        fill={color}
        d="M0 15.5v-9a1.986 1.986 0 0 1 .8-1.6l6-4.5C7.15.133 7.55 0 8 0c.45 0 .85.133 1.2.4l6 4.5c.25.183.446.417.587.7.142.283.213.583.213.9v9c0 .55-.196 1.02-.588 1.412A1.926 1.926 0 0 1 14 17.5h-3a.967.967 0 0 1-.713-.288A.967.967 0 0 1 10 16.5v-5a.967.967 0 0 0-.288-.713A.967.967 0 0 0 9 10.5H7a.967.967 0 0 0-.713.287A.967.967 0 0 0 6 11.5v5c0 .283-.096.52-.288.712A.967.967 0 0 1 5 17.5H2c-.55 0-1.02-.196-1.413-.588A1.926 1.926 0 0 1 0 15.5Z"
      />
    </Svg>
  );
}
HomeIcon.displayName = "HomeIcon";
export default HomeIcon;